import { render, staticRenderFns } from "./FeedBackAdd.vue?vue&type=template&id=0349f3a7&"
import script from "./FeedBackAdd.vue?vue&type=script&lang=js&"
export * from "./FeedBackAdd.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports